import React, { useState, useEffect } from 'react'
import { TextField, Grid, Box, Button } from "@mui/material"
import FreeRideState from '../../Hooks/FreeRide.state'
const RideFormSix = ({ handleBack, handleComplete, freeRideData, setFreeRideData }) => {
  const [info, setInfo] = useState("")
  const {SaveFreeRide,formBusy,response} = FreeRideState()
  useEffect(() => {
    setInfo(freeRideData.additional_info)
  }, [])
  const onSubmit = () => {
    const payload = {
      ...freeRideData,
      created_at: freeRideData?.created_at || freeRideData?.started_from
    };
    SaveFreeRide(payload)
    handleComplete()
  }
  const onChangeValue = (e) => {
    setInfo(e.target.value)
    setFreeRideData((prev) => ({
      ...prev,
      additional_info: e.target.value
    }))
  }

 

  

  return (
    <div >


      {/* <div style={{display:"flex",flexDirection:"column",textAlign:"left",marginTop:20}} >
        <label>Receiving Facility Name</label>
        <TextField style={{marginBottom:20}} placeholder="Receiving Facility Name" />
        </div> */}
      <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }} >

        <label>Additional Info</label>
        <TextField placeholder='Additional Info' multiline maxRows={4} minRows={4} value={info} onChange={onChangeValue} />
      </div>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{minWidth:"10%", border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={onSubmit}>
        {formBusy?"Please wait...":"Submit"}
        </Button>

      </Box>
    </div>
  )
}

export default RideFormSix